module.exports = new __parcel__URL__("Profile.083c7f47.webp").toString();